import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=fbe6ec76"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports